import React from 'react';
import Button from "components/button";
import UseContext from "hooks/useContext";
import {dateWord} from "helper/helper";
import ContentMotif from "pages/createMission/content.motif";
import {Calendar} from "../../../assets/icons";
import SectionWrapper from "../components/SectionWrapper";

const Confirmation = () => {
    const {data,setPage} = UseContext()

    return (
        <SectionWrapper 
            title="Confirmation" 
            description="Vérifiez les informations de votre mission avant de la créer. Vous pouvez modifier chaque section si nécessaire."
        >
            <div className={'flex flex-col gap-6'}>
            <div className={'flex flex-col gap-4 border border-gray-100 rounded-md p-4'}>
                <div className={'flex justify-end'}>
                    <Button color={'DEFAULT'} onClick={()=>{setPage(1)}} size={'SM'}>Modifier</Button>
                </div>
                <span className='ft-xl font-medium text-gray-900'>Description</span>
                <div className={'ft-sm text-gray-500'}>Secteur d'activité : <span className={'text-gray-900'}>{data.activity}</span></div>
                <div className={'ft-sm text-gray-500'}>Qualification : <span className={'text-gray-900'}>{data.qualification}</span></div>
            </div>
            <div className={'flex flex-col gap-4 border border-gray-100 rounded-md p-4'}>
                <div className={'flex justify-end'}>
                    <Button color={'DEFAULT'} onClick={()=>{setPage(2)}} size={'SM'}>Modifier</Button>
                </div>
                <span className='ft-xl font-medium text-gray-900'>Pré-requis</span>
                <div className={'ft-sm text-gray-500'}>Matériel : <span className={'text-gray-900'}>{data.tools.length > 0 ? data.tools.join(', ') : 'Aucun'}</span></div>
                <div className={'ft-sm text-gray-500'}>Permis : <span className={'text-gray-900'}>{data.licences.length > 0 ? data.licences.join(', ') : 'Aucun'}</span></div>
                <div className={'ft-sm text-gray-500'}>Langues : <span className={'text-gray-900'}>{data.languages.length > 0 ? data.languages.join(', ') : 'Aucune'}</span></div>
            </div>
            <div className={'flex flex-col gap-4 border border-gray-100 rounded-md p-4'}>
                <div className={'flex justify-end'}>
                    <Button color={'DEFAULT'} onClick={()=>{setPage(3)}} size={'SM'}>Modifier</Button>
                </div>
                <span className='ft-xl font-medium text-gray-900'>Motif de recrutement</span>
                    <ContentMotif/>
            </div>
            <div className={'flex flex-col gap-4 border border-gray-100 rounded-md p-4'}>
                <div className={'flex justify-end'}>
                    <Button color={'DEFAULT'} onClick={()=>{setPage(4)}} size={'SM'}>Modifier</Button>
                </div>
                <span className='ft-xl font-medium text-gray-900'>Lieu et dates</span>
                <div className={'ft-sm text-gray-500'}>Adresse : <span className={'text-gray-900'}>{data.location.street + ', ' + data.location.postcode + ' ' + data.location.city}</span></div>
                <div className={'flex justify-between items-center'}>
                    <div className={'ft-sm text-gray-500'}>Période : <span className={'text-gray-900'}>{data.dateStart && data.dateEnd ? `${dateWord(data.dateStart)} au ${dateWord(data.dateEnd)}` : '-'}</span></div>
                    {data.isScheduleCheck && (
                        <Button color={'SECONDARY'} size={'SM'} onClick={() => setPage(5)}>
                            <Calendar wh={16} color={'#374151'} />
                            <span className="ml-1">Planning</span>
                                        </Button>
                    )}
                </div>
            </div>
            <div className={'flex flex-col gap-4 border border-gray-100 rounded-md p-4'}>
                <div className={'flex justify-end'}>
                    <Button color={'DEFAULT'} onClick={()=>{setPage(8)}} size={'SM'}>Modifier</Button>
                </div>
                <span className='ft-xl font-medium text-gray-900'>Responsable</span>
                <div className={'ft-sm text-gray-500'}>Nom : <span className={'text-gray-900'}>{data.contact_name}</span></div>
                <div className={'ft-sm text-gray-500'}>Fonction : <span className={'text-gray-900'}>{data.contact_poste}</span></div>
            </div>
            <div className={'flex flex-col gap-4 border border-gray-100 rounded-md p-4'}>
                <div className={'flex justify-end'}>
                    <Button color={'DEFAULT'} onClick={()=>{setPage(6)}} size={'SM'}>Modifier</Button>
                </div>
                <span className='ft-xl font-medium text-gray-900'>Rémunération</span>
                <div className={'ft-sm text-gray-500'}>Taux horaire : <span className={'text-gray-900'}>{data.salary} €/h</span></div>
            </div>
            <div className={'flex flex-col gap-4 border border-gray-100 rounded-md p-4'}>
                <div className={'flex justify-end'}>
                    <Button color={'DEFAULT'} onClick={()=>{setPage(7)}} size={'SM'}>Modifier</Button>
                </div>
                <span className='ft-xl font-medium text-gray-900'>Invitations</span>
                {data.users_invite && data.users_invite.length > 0 ? (
                    <div className="flex flex-wrap gap-2">
                        {data.users_invite.map((tempWorker, index) => (
                            <span key={index} className="px-2 py-1 bg-gray-100 rounded-lg ft-sm text-gray-700">
                                {tempWorker.name}
                            </span>
                        ))}
                </div>
                ) : (
                    <span className="ft-sm text-gray-400">Aucun intérimaire invité</span>
                )}
            </div>
            <div className={'flex flex-col gap-4 border border-gray-100 rounded-md p-4'}>
                <div className={'flex justify-end'}>
                    <Button color={'DEFAULT'} onClick={()=>{setPage(9)}} size={'SM'}>Modifier</Button>
                </div>
                <span className='ft-xl font-medium text-gray-900'>Informations supplémentaires</span>
                <div className={'ft-sm text-gray-500'}>Pour le candidat : <span className={'text-gray-900'}>{data.other || 'Aucune information'}</span></div>
                <div className={'ft-sm text-gray-500'}>Pour l'agence : <span className={'text-gray-900'}>{data.other_interim || 'Aucune information'}</span></div>
            </div>
            </div>
        </SectionWrapper>
    );
};

export default Confirmation;